import * as tslib_1 from "tslib";
import * as React from 'react';
import omit from 'lodash/omit';
import cn from 'astro-classname';
import '../alert/index.css';
var BLACK_LIST = [
    'className',
    'prefix',
    'closable',
    'visiable',
    'message',
    'theme',
    'onClose'
];
var Alert = (function (_super) {
    tslib_1.__extends(Alert, _super);
    function Alert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visiable: true,
        };
        _this.onClose = function (e) {
            var onClose = _this.props.onClose;
            if (onClose) {
                onClose(e);
            }
            if (e.defaultPrevented) {
                return;
            }
            _this.setState({ visiable: false });
        };
        return _this;
    }
    Alert.getDerivedStateFromProps = function (nextProps) {
        if ('visiable' in nextProps) {
            return {
                visiable: nextProps.visiable,
            };
        }
        return null;
    };
    Alert.prototype.render = function () {
        var _a;
        var visiable = this.state.visiable;
        if (!visiable) {
            return null;
        }
        var _b = this.props, className = _b.className, prefix = _b.prefix, message = _b.message, theme = _b.theme, closable = _b.closable;
        var classes = cn(className, prefix + "-wrapper", (_a = {},
            _a[prefix + "-wrapper-" + theme] = theme,
            _a));
        var nodeProps = omit(this.props, BLACK_LIST);
        return (React.createElement("div", tslib_1.__assign({ className: classes }, nodeProps),
            closable && React.createElement("span", { className: prefix + "-closable", onClick: this.onClose }),
            React.createElement("div", { className: prefix + "-inner" }, message)));
    };
    Alert.defaultProps = {
        className: '',
        prefix: 'zhui-alert',
        closable: false
    };
    return Alert;
}(React.Component));
export default Alert;
